import apiFn from 'common/services/api-service';

const api = () => apiFn('/api/cms/v1/packages/blueprints');

export const listPackages = async type =>
  api()
    .get('', { params: { packageType: type } })
    .then(response => response.data);
